import { Injectable, Input } from '@angular/core';
import { SessionsProvider } from '../../sessions/providers/sessions-provider';
import { TimeslotRow } from './timeslots-provider';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { CurrentUser } from "../../common/providers/current-user";
import { Timeslot } from "../../common/models/timeslot";

@Injectable({providedIn: 'root'})
export class TimeslotsChangesProvider {

    @Input() public set removedRepetitionTags(tags: string[]) {
        this._removedRepetitionTags = tags;
    }
    public get removedRepetitionTags() {
        return this._removedRepetitionTags;
    }

    @Input() public set repeatedTimeslotRows(tsrs: TimeslotRow[]) {
        this._repeatedTimeslotRows = tsrs;
    }
    public get repeatedTimeslotRows() {
        return this._repeatedTimeslotRows;
    }
    private _removedRepetitionTags: string[] = [];
    private _repeatedTimeslotRows: TimeslotRow[] = [];
    constructor(
        private _utils: UtilsProvider,
        private _currentUser: CurrentUser,
        private _sessionsProvider: SessionsProvider,
    ) { }

    public addRepetitionTagToRemove(tag: string) {
        this._removedRepetitionTags.push(tag);
        this.removeRepTagFromRepeatedTimeslots(tag);
        // this.debug();
    }

    public addRepeatedTimeslotRow(tsr: TimeslotRow) {
        this._repeatedTimeslotRows.push(tsr);
        // this.debug();
    }

    public getRepeatedTimeslots(): Timeslot[] {
        return this._utils.getKeyValues(this._repeatedTimeslotRows, 'timeslot');
    }

    public resetAll() {
        this.resetRemovedRepetitionTags();
        this.resetRepeatedTimeslotRows();
    }

    public resetRemovedRepetitionTags() {
        this._removedRepetitionTags = [];
    }

    public resetRepeatedTimeslotRows() {
        this._repeatedTimeslotRows = [];
    }

    public debug() {
    }

    private removeRepTagFromRepeatedTimeslots(tag: any) {
        if (this._repeatedTimeslotRows) {
            for (let i = (this._repeatedTimeslotRows.length - 1); i >= 0; i--) {
                if (this._repeatedTimeslotRows[i].timeslot?.repetitionTag === tag) {
                    this._repeatedTimeslotRows.splice(i, 1);
                }
            }
        }
    }
}
